import intlTelInput from 'intl-tel-input';
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone-input"
export default class extends Controller {
  static values = {
    initialCountry: String
  }

  connect() {
    console.log("Phone input connected")
    this.telInput = intlTelInput(this.element.getElementsByTagName('input')[0], {
      initialCountry: this.initialCountry,
      autoPlaceholder: 'aggressive',
      separateDialCode: true,
      strictMode: true,
      hiddenInput: function(telInputName) {
        const modelName = telInputName.split('[')[0]
        return {
          phone: `${modelName}[phone_number]`,
          country: `${modelName}[phone_country_code]`
        };
      },
      loadUtilsOnInit: () => import("intl-tel-input/utils"),
      geoIpLookup: function(success, failure) {
        fetch("https://ipapi.co/json")
          .then(function(res) { return res.json(); })
          .then(function(data) { success(data.country_code); })
          .catch(function() { failure(); });
      }
    })
  }

  disconnect() {
    this.telInput.destroy()
  }

  get initialCountry() {
    return this.hasInitialCountryValue ? this.initialCountryValue : 'auto'
  }
}
